export class PasswordValidation {
    public isValid: boolean;
    public message: string;
    public policyName: string;
}